// extracted by mini-css-extract-plugin
export default {"icons":"Navbar_icons__hKEAa","text":"Navbar_text__w9YVo"};